(() => {
  const randomize = (root) => {
    const items = [...root.querySelectorAll('.resource-list__item')]
      .filter((item) => item.querySelector('.norgira-pdp-related-home-card'));
    if (items.length < 4 || root.dataset.norgiraRelatedRandomized === 'true') return;

    const shuffled = [...items];
    for (let index = shuffled.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [shuffled[index], shuffled[randomIndex]] = [shuffled[randomIndex], shuffled[index]];
    }
    shuffled.forEach((item, index) => {
      item.hidden = index >= 4;
      if (index < 4) item.parentElement?.appendChild(item);
    });
    root.dataset.norgiraRelatedRandomized = 'true';
  };

  const observe = () => {
    document.querySelectorAll('product-recommendations').forEach((root) => {
      randomize(root);
      if (root.dataset.norgiraRelatedObserver === 'true') return;
      root.dataset.norgiraRelatedObserver = 'true';
      new MutationObserver(() => randomize(root)).observe(root, { childList: true, subtree: true });
    });
  };

  document.addEventListener('DOMContentLoaded', observe, { once: true });
  observe();
})();


